import React, { useEffect } from "react";
import { FaCheckCircle, FaTimes } from "react-icons/fa";

const CartSuccessPopup = ({ message, onClose }) => {
  useEffect(() => {
    // Auto-close after 8 seconds
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    
    return () => clearTimeout(timer); // Cleanup on unmount
  }, [onClose]);

  return (
    <div className="fixed top-[12%] right-[8%] bg-tertiary border-2 border-hcolor text-hcolor px-6 py-3 rounded-lg shadow-lg flex items-center gap-3 animate-slideIn">
      <FaCheckCircle className="text-2xl" />
      <span className="text-lg font-medium">{message || "Item added to cart!"}</span>
      <FaTimes className="ml-3 cursor-pointer text-xl hover:text-gray-300" onClick={onClose} />
    </div>
  );
};

export default CartSuccessPopup;

